import { useEffect, useRef } from 'react';

const usePrevious = (currentValue: any) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = currentValue;
  }, [currentValue]);
  return ref.current;
};

export default usePrevious;
